import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ImageOffIcon = function ImageOffIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ImageOffIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1.487 1.487a.725.725 0 0 1 1.026 0L3.684 2.66a.7.7 0 0 1 .162.162l3.99 3.99.01.01 3.333 3.333.01.01 3.324 3.323a.725.725 0 0 1-1.026 1.026l-.809-.81c-.406.231-.869.356-1.345.355H4.667a2.725 2.725 0 0 1-2.725-2.725V4.667c0-.49.13-.948.355-1.345l-.81-.81a.725.725 0 0 1 0-1.025m1.925 2.95 1.97 1.97a2.5 2.5 0 0 0-.551.404l-.01.01L3.39 8.25V4.667q0-.117.021-.23m-.02 6.896V10.3L5.84 7.851c.198-.189.369-.24.492-.24s.292.05.49.237l4.74 4.74q-.114.02-.23.02H4.668a1.275 1.275 0 0 1-1.275-1.275m5.883-6c0-.4.325-.725.725-.725h.007a.725.725 0 0 1 0 1.45H10a.725.725 0 0 1-.725-.725M5.333 1.942a.725.725 0 0 0 0 1.45h6a1.275 1.275 0 0 1 1.275 1.275V8.25l-.096-.096-.01-.01c-.467-.45-1.06-.704-1.696-.639a.725.725 0 0 0 .148 1.443c.132-.014.318.026.539.237l1.115 1.115v.367a.725.725 0 0 0 1.45 0v-6a2.725 2.725 0 0 0-2.725-2.725z",
      clipRule: "evenodd"
    })
  }));
};

export { ImageOffIcon };
